import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e7c953c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-movie" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Add Movie", -1))
const _hoisted_3 = { class: "p-fluid add-movie__panel" }
const _hoisted_4 = { class: "p-field add-movie__row" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Movie Name", -1))
const _hoisted_6 = { class: "p-field add-movie__row add-movie__poster" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "p-field add-movie__row" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "rating" }, "Rating", -1))
const _hoisted_10 = { class: "p-field add-movie__row" }
const _hoisted_11 = { class: "p-field add-movie__row" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "year" }, "Date Seen", -1))
const _hoisted_13 = { class: "p-field add-movie__row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Knob = _resolveComponent("Knob")!
  const _component_ToggleButton = _resolveComponent("ToggleButton")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_AutoComplete, {
          id: "name",
          modelValue: _ctx.selectedMovie,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedMovie) = $event)),
          suggestions: _ctx.suggestions,
          onComplete: _cache[1] || (_cache[1] = ($event: any) => (_ctx.movieSearch($event))),
          onItemSelect: _ctx.movieSelected,
          onClear: _ctx.movieCleared,
          field: "name",
          class: _normalizeClass(["add-movie__field", _ctx.invalid ? 'p-invalid' : '']),
          forceSelection: "",
          dropdownMode: "current"
        }, {
          item: _withCtx((slotProps) => [
            _createElementVNode("div", null, _toDisplayString(slotProps.item.name), 1)
          ]),
          _: 1
        }, 8, ["modelValue", "suggestions", "onItemSelect", "onClear", "class"])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_6, [
        _createElementVNode("img", {
          src: _ctx.selectedMovie?.poster?.url,
          class: "add-movie__image"
        }, null, 8, _hoisted_7)
      ], 512), [
        [_vShow, _ctx.itemSelected]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_Knob, {
          modelValue: _ctx.rating,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.rating) = $event)),
          id: "rating",
          size: 150,
          class: "add-movie__rating"
        }, null, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.itemSelected]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_10, [
        _createVNode(_component_ToggleButton, {
          modelValue: _ctx.flagged,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.flagged) = $event)),
          onLabel: "Flagged",
          offLabel: "Unflagged"
        }, null, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.itemSelected]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _createVNode(_component_Calendar, {
          id: "date",
          modelValue: _ctx.selectedDate,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedDate) = $event)),
          showIcon: false,
          showTime: false,
          selectionMode: "single",
          maxDate: new Date()
        }, null, 8, ["modelValue", "maxDate"])
      ], 512), [
        [_vShow, _ctx.itemSelected]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_13, [
        _createVNode(_component_Button, {
          label: _ctx.saving ? 'Saving' : 'Save',
          onClick: _ctx.save,
          disabled: _ctx.saving
        }, null, 8, ["label", "onClick", "disabled"])
      ], 512), [
        [_vShow, _ctx.itemSelected]
      ])
    ])
  ]))
}